import { ServiceResult } from '../models';
import {
  CopyRecipeHeaderRequest,
  CreateRecipeHeaderRequest,
  DeleteRecipeHeaderRequest,
  RecipeHeader,
  UpdateHiddenSecretRecipeHeaderRequest,
  UpdateRecipeHeaderRequest,
} from '../models/recipe-header.models';
import ApiService from './api-service';

class RecipeHeaderService extends ApiService {
  private static classInstance: RecipeHeaderService;

  private constructor() {
    super('RecipeHeader');
  }

  public static getInstance(): RecipeHeaderService {
    if (!this.classInstance) {
      this.classInstance = new RecipeHeaderService();
    }
    return this.classInstance;
  }

  public getRecipeHeader(recipeHeaderId: string, customerId: string): ServiceResult<RecipeHeader> {
    return this.get(`${this.baseUrl}/GetRecipeHeader?recipeHeaderId=${recipeHeaderId}&customerId=${customerId}`);
  }

  public getRecipeHeaders(customerId: string, menuHeaderId?: string): ServiceResult<RecipeHeader[]> {
    return this.get(
      `${this.baseUrl}/GetRecipeHeaders?customerId=${customerId}${
        menuHeaderId ? '&viewFromRecipeMenuHeaderId=' + menuHeaderId : ''
      }`
    );
  }

  public getRecipeHeadersByIngredientId(customerId: string, ingredientId: string): ServiceResult<RecipeHeader[]> {
    return this.get(
      `${this.baseUrl}/GetRecipeHeadersByIngredientId?customerId=${customerId}&ingredientId=${ingredientId}`
    );
  }

  public getRecipeHeadersBySubRecipeHeaderId(
    customerId: string,
    subRecipeHeaderId: string
  ): ServiceResult<RecipeHeader[]> {
    return this.get(
      `${this.baseUrl}/GetRecipeHeadersBySubRecipeHeaderId?customerId=${customerId}&subRecipeHeaderId=${subRecipeHeaderId}`
    );
  }

  public createRecipeHeader(request: CreateRecipeHeaderRequest): ServiceResult<RecipeHeader> {
    return this.post(`${this.baseUrl}/CreateRecipeHeader`, request);
  }

  public updateRecipeHeader(request: UpdateRecipeHeaderRequest): ServiceResult<RecipeHeader> {
    return this.post(`${this.baseUrl}/UpdateRecipeHeader`, request);
  }

  public updateHiddenRecipeHeader(payload: {
    RecipeUpdates: UpdateHiddenSecretRecipeHeaderRequest[];
    ViewAsCustomerId: string;
  }): ServiceResult<RecipeHeader[]> {
    return this.post(`${this.baseUrl}/UpdateHiddenRecipeHeaders`, payload);
  }

  public updateSecretRecipeHeader(payload: {
    RecipeUpdates: UpdateHiddenSecretRecipeHeaderRequest[];
    ViewAsCustomerId: string;
  }): ServiceResult<RecipeHeader[]> {
    return this.post(`${this.baseUrl}/UpdateSecretRecipeHeaders`, payload);
  }

  public deleteRecipeHeader(request: DeleteRecipeHeaderRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeHeader`, request);
  }

  public copyRecipeHeader(request: CopyRecipeHeaderRequest): ServiceResult<RecipeHeader> {
    return this.post(`${this.baseUrl}/CopyRecipeHeader`, request);
  }
}

export default RecipeHeaderService;
